/* Product page behaviour: thumbnail gallery, Overview/Ingredients/Directions
   tabs, and the optional Read More toggle. Add-to-cart is Dawn's
   product-form.js, which renders into the cart drawer. */

if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.main = this.querySelector('[data-gallery-main]');
        this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumb'));
        if (!this.main || !this.thumbs.length) return;

        // thumbnail strip: chevrons only when the thumbs overflow the strip
        this.strip = this.querySelector('.product-gallery__thumbs');
        this.arrows = Array.from(this.querySelectorAll('[data-gallery-scroll]'));
        this.arrows.forEach((arrow) => {
          arrow.addEventListener('click', () => {
            const step = this.strip.clientWidth * 0.8 * Number(arrow.dataset.galleryScroll);
            this.strip.scrollBy({ left: step, behavior: 'smooth' });
          });
        });
        this.updateArrows();
        window.addEventListener('resize', () => this.updateArrows(), { passive: true });
        this.strip.addEventListener('scroll', () => this.updateArrows(), { passive: true });

        this.thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.select(index));
          thumb.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
              event.preventDefault();
              const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.thumbs.length) % this.thumbs.length;
              this.select(next);
              this.thumbs[next].focus();
            }
          });
        });
      }

      select(index) {
        const thumb = this.thumbs[index];
        if (!thumb || thumb.classList.contains('is-active')) return;

        this.main.src = thumb.dataset.src;
        this.main.srcset = thumb.dataset.srcset;
        this.main.alt = thumb.dataset.alt || '';
        if (thumb.dataset.width) this.main.width = thumb.dataset.width;
        if (thumb.dataset.height) this.main.height = thumb.dataset.height;

        this.thumbs.forEach((t, i) => {
          const active = i === index;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
        });
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.strip || !this.arrows.length) return;
        const overflow = this.strip.scrollWidth > this.strip.clientWidth + 1;
        this.strip.classList.toggle('product-gallery__thumbs--centered', !overflow);
        const atStart = this.strip.scrollLeft <= 1;
        const atEnd = this.strip.scrollLeft + this.strip.clientWidth >= this.strip.scrollWidth - 1;
        this.arrows.forEach((arrow) => {
          const prev = Number(arrow.dataset.galleryScroll) < 0;
          arrow.hidden = !overflow;
          arrow.disabled = overflow && (prev ? atStart : atEnd);
          arrow.style.opacity = arrow.disabled ? '0.35' : '';
        });
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  // Tabs
  const tabs = Array.from(document.querySelectorAll('#product-vetiq .tabs-row [role="tab"]'));
  const panels = Array.from(document.querySelectorAll('#product-vetiq .tabs-row [role="tabpanel"]'));

  const activate = (tab) => {
    tabs.forEach((t) => {
      const active = t === tab;
      t.classList.toggle('active', active);
      t.setAttribute('aria-selected', String(active));
      t.tabIndex = active ? 0 : -1;
    });
    panels.forEach((panel) => {
      const active = panel.id === tab.getAttribute('aria-controls');
      panel.classList.toggle('active', active);
      panel.hidden = !active;
    });
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab));
    tab.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      activate(next);
      next.focus();
    });
  });

  // Read More (cat template clamps the description to 4 lines)
  const readMore = document.querySelector('#product-vetiq [data-read-more]');
  const description = document.querySelector('#product-vetiq [data-description]');
  if (readMore && description) {
    readMore.addEventListener('click', () => {
      const expanded = description.classList.toggle('is-clamped') === false;
      readMore.setAttribute('aria-expanded', String(expanded));
      readMore.textContent = expanded ? 'Read Less' : 'Read More';
    });
  }
});
